module.exports = __webpack_public_path__ + "img/two-phone.599c283e.png";